import React, { useEffect, useState } from "react";

// Material Dashboard 2 React components
import MDTypography from "components/MDTypography";
import Loader from "Loader";
import DataTable from "examples/Tables/DataTable";
import CreateAppointmentWithHoursReq from "../../../Classes/Models/Requests/Appointments/CreateAppointmentWithHoursReq";
import AppointmentsApi from "../../../Classes/API/Appointments/AppointmentsApi";
import Swal from "sweetalert2";
const AppPrioTable = ({ Apps, AppHour }) => {
  console.log(Apps);
  const TableColumns = [
    { Header: "Id", accessor: "Id", width: "5%", align: "left" },

    { Header: "Patient Name", accessor: "PatientName", align: "left" },
    { Header: "Priority", accessor: "Priority", align: "left" },
    { Header: "Session Name", accessor: "SessionName", align: "center" },
    { Header: "AccSession ID", accessor: "AccSessionId", align: "center" },
    { Header: "PaidFor?", accessor: "IsPaidFor", align: "center" },
    { Header: "Action", accessor: "Action", align: "center" },
  ];

  const [TableDataRows, setTableDataRows] = useState([]);

  const [IsLoaded, setIsLoaded] = useState(false);

  const ConfirmAppointment = async (appHourApp, isSplit, isFirstHalf) => {
    let req = new CreateAppointmentWithHoursReq();
    req.id = appHourApp.getAppointment.id;
    req.Priority = appHourApp.priority;
    req.IsSplit = isSplit;
    req.IsFirstHalf = isFirstHalf;
    req.AppHourId = AppHour.id;

    let res = await AppointmentsApi.ConfirmAppointment(req);

    if (res.status == "Success") {
      Swal.fire("Success", res.message, "success").then(() => {
        window.location.reload();
      });
    } else {
      Swal.fire("Failed", res.message, "error");
    }
  };

  const GetOtherTherapists = (app) => {
    let Therapists = [];
    app.getAppointmentHours.forEach((hour) => {
      if (
        Therapists.indexOf(
          hour.getAppointmentHour.getAppointmentDayTherapist.getTherapist.getUser.name
        ) == -1
      ) {
        Therapists.push(
          hour.getAppointmentHour.getAppointmentDayTherapist.getTherapist.getUser.name
        );
      }
    });
    return Therapists.join(", ");
  };

  useEffect(() => {
    const MakeTableRow = (app, appHourApp) => {
      return {
        Id: (
          <MDTypography component="p" variant="button" color="text" fontWeight="medium">
            {app.id}
          </MDTypography>
        ),
        PatientName: (
          <MDTypography component="p" variant="button" color="text" fontWeight="medium">
            {app.getAccountingSession.getPatient.getUser.name}
          </MDTypography>
        ),

        Priority: (
          <MDTypography component="p" variant="button" color="text" fontWeight="medium">
            {appHourApp.priority}
          </MDTypography>
        ),

        Therapists: (
          <MDTypography component="p" variant="button" color="text" fontWeight="medium">
            {GetOtherTherapists(app)}
          </MDTypography>
        ),

        SessionName: (
          <MDTypography component="p" variant="button" color="text" fontWeight="medium">
            {app.getAccountingSession.getSession.name}
          </MDTypography>
        ),

        AccSessionId: (
          <MDTypography component="p" variant="button" color="text" fontWeight="medium">
            {app.getAccountingSession.id}
          </MDTypography>
        ),

        IsPaidFor: (
          <MDTypography component="p" variant="button" color="text" fontWeight="medium">
            {app.getAccountingSession.isPaidFor ? "YES" : "NO"}
          </MDTypography>
        ),

        Action: (
          // Confrim Appointment button dark
          <MDTypography component="a" variant="button" color="text" fontWeight="medium">
            {!app.getAccountingSession.getSession.isHalfDuration ? (
              <button
                onClick={() => ConfirmAppointment(appHourApp, false, false)}
                className="btn btn-dark btn-sm"
              >
                Confirm Appointment{" "}
              </button>
            ) : (
              <>
                <button
                  onClick={() => ConfirmAppointment(appHourApp, true, true)}
                  className="btn btn-dark btn-sm"
                >
                  Confirm Appointment First Half{" "}
                </button>
                <button
                  onClick={() => ConfirmAppointment(appHourApp, true, false)}
                  className="btn btn-info ml-2 btn-sm"
                >
                  Confirm Appointment Second Half{" "}
                </button>
              </>
            )}
          </MDTypography>
        ),
      };
    };
    const RefreshTable = (resList) => {
      var rows = [];
      resList.forEach((app) => {
        rows.push(MakeTableRow(app && app.getAppointment, app));
      });
      setTableDataRows(rows);
      setIsLoaded(true);
    };
    RefreshTable(Apps);
  }, []);

  if (!IsLoaded) {
    const loaderType = "balls";
    const loaderColor = "grey";

    return <Loader type={loaderType} color={loaderColor} />;
  }

  return (
    <DataTable
      table={{ columns: TableColumns, rows: TableDataRows }}
      isSorted={false}
      entriesPerPage={false}
      showTotalEntries={false}
      noEndBorder
    />
  );
};

export default AppPrioTable;
